<template>
    <div class="row pl-3 pr-3 pb-3 pt-0 mt-0">
        <div class="col-12 mb-3">
            <u><h5 class="font-weight-bold">Datos de los responsables</h5></u>
        </div>
        <div class="col-12 col-lg-6">
            <FormInput label="Nombre responsable 1" type="text" name="nombre_responsable" id="nombre_responsable" rules="required" v-model="base.nombre_responsable" />
            <FormInput label="Apellidos responsable 1" type="text" name="apellidos_responsable" id="apellidos_responsable" rules="required" v-model="base.apellidos_responsable" />
            <FormInput label="DNI responsable 1" type="text" name="dni_responsable" id="dni_responsable" rules="required" v-model="base.dni_responsable" />
            <FormInput label="Email responsable 1" type="text" name="email_responsable" id="email_responsable" rules="required" v-model="base.email_responsable" />
            <FormInput label="Teléfono responsable 1" type="text" name="telefono_responsable" id="telefono_responsable" rules="required" v-model="base.telefono_responsable" />
        </div>
        <div class="col-12 col-lg-6">
            <FormInput label="Nombre responsable 2" type="text" name="nombre_responsable_2" id="nombre_responsable_2" rules="" v-model="base.nombre_responsable_2" />
            <FormInput label="Apellidos responsable 2" type="text" name="apellidos_responsable_2" id="apellidos_responsable_2" rules="" v-model="base.apellidos_responsable_2" />
            <FormInput label="DNI responsable 2" type="text" name="dni_responsable_2" id="dni_responsable_2" rules="" v-model="base.dni_responsable_2" />
            <FormInput label="Email responsable 2" type="text" name="email_responsable_2" id="email_responsable_2" rules="" v-model="base.email_responsable_2" />
            <FormInput label="Teléfono responsable 2" type="text" name="telefono_responsable_2" id="telefono_responsable_2" rules="" v-model="base.telefono_responsable_2" />
        </div>
    </div>
</template>

<script>
    export default {
        props: ['base']
    }

</script>